/**
 * Bonus Engine Wagering Types
 */
enum BonusEngineWageringType {
  ROUNDS = 'ROUNDS',
  TURNOVER = 'TURNOVER',
}

export default BonusEngineWageringType
